export default "__VITE_ASSET__DSBCCs6p__"